import { render, staticRenderFns } from "./ViewJob.vue?vue&type=template&id=3606ff36&"
import script from "./ViewJob.vue?vue&type=script&lang=js&"
export * from "./ViewJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports